import React, { Component } from 'react';
import animateScrollTo from 'animated-scroll-to';
import ContactButtons from './ContactButtonsComponent';
import ContactForm from '../containers/ContactFormContainer';

class ContactSectionComponent extends Component {
    componentDidMount() {
        animateScrollTo(0, { speed: 700 });
    }

    render() {
        return (
            <section className="sectionContact">
                <header>
                    <h1>Entre em Contato</h1>
                    <p className="pageSubtitle">Dúvidas, sugestões ou feedback? Preencha o formulário e fale conosco!</p>
                </header>
                {/* <p className="titleForm">Envie uma Mensagem</p> */}
                <ContactForm />
                <ContactButtons />
            </section>
        );
    }
}

export default ContactSectionComponent;
